import { ExportTypeBaseService } from '@/modules/export/services/ExportTypeBaseService';
import { ExportType } from '@/modules/export/constants/ExportType';
import Lang from '@/modules/core/app/services/Lang';
import dayjs from 'dayjs';
import { DateFormat } from '@/modules/core/app/constants/date.constants';

export class CainLamarreReceiptsSummaryExportService extends ExportTypeBaseService {
  constructor(params: Params) {
    super({
      type: ExportType.CAIN_LAMARRE_RECEIPTS_SUMMARY,
      ...params
    });
  }

  getSnackBarTitle(): string {
    return Lang.t('export.cain-lamarre-summary-filename', {
      date: dayjs.unix(this.params.end ?? 0).format(DateFormat.ISO)
    });
  }

  getFilename(): string {
    return Lang.t('export.cain-lamarre-summary-filename', {
      date: dayjs.unix(this.params.end ?? 0).format(DateFormat.ISO)
    });
  }
}
